export const resultsContent = {
  title: "Our Clients Get Results",
  subtitle: "Here’s what we’ve helped businesses achieve:",
  subtitle1: "Proven track record",
  stats: [
    {
      label: "Bid Out",
      value: "$514M+",
    },
    {
      label: "Won or in Negotiations",
      value: "$115M+",
    },
    {
      label: "Win Rate",
      value: "1 in 8",
    },
    {
      label: "Years Combined of Experience",
      value: "50+",
    },
    {
      label: "Hours of Estimating",
      value: "10,000+",
    },
    {
      label: "Supported Contractors",
      value: "75+",
    },
  ],
};
